// API Variables
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

export const USERS_URL = `${API_BASE_URL}/users/`
export const CLIENTS_URL = `${API_BASE_URL}/clients/`
export const REPORTS_URL = `${API_BASE_URL}/reports/`
export const LOCATIONS_URL = `${API_BASE_URL}/locations/`
export const VEHICLES_URL = `${API_BASE_URL}/vehicles/`
export const CLAIMS_URL = `${API_BASE_URL}/claims/`
export const CHRONOLOGY_URL = `${API_BASE_URL}/chronology/`

export const MAKERS_URL = `${VEHICLES_URL}makers/`
export const BRANDS_URL = `${VEHICLES_URL}brands/`
export const MODELS_URL = `${VEHICLES_URL}models/`
export const INSURANCE_URL = `${API_BASE_URL}/insurance/`
export const CLAIM_DATA_URL = (VEHICLE_ID) => `${VEHICLES_URL}${VEHICLE_ID}/claims/`
export const CLAIM_DETAIL_DATA_URL = (VEHICLE_ID, CLAIM_ID) => `${VEHICLES_URL}${VEHICLE_ID}/claims/${CLAIM_ID}/`

export const WORKSHOPS_URL = `${INSURANCE_URL}workshops/`

export const UPDATE_WORKSHOP = (WORKSHOP_ID) => `${WORKSHOPS_URL}${WORKSHOP_ID}/`

export const INSCURANCE_COMPANIES_URL = `${INSURANCE_URL}companies/`
export const INSCURANCE_COVERAGES_URL = `${INSURANCE_URL}coverages/`
export const INSCURANCE_BROKERS_URL = `${INSURANCE_URL}brokers/`

export const LOGIN_URL = `${USERS_URL}login/`
export const USER_PRIVILEGES_URL = `${USERS_URL}admin-privileges/`
export const USER_PROFILE_URL = (USER_ID) => `${USERS_URL}${USER_ID}/`
export const UPDATE_PROFILE_PICTURE_URL = (USER_ID) => `${USERS_URL}${USER_ID}/picture/`
export const UPDATE_USER_PASSWORD_URL = (USER_ID) => `${USERS_URL}${USER_ID}/password/`
export const PASSWORD_RECOVERY_URL = `${USERS_URL}recover-password/`
export const ACTIVATE_SET_PASSWORD_URL = (USER_ID) => `${USERS_URL}${USER_ID}/activate-set-password/`
export const SET_NEW_PASSWORD_URL = (USER_ID, TOKEN) => `${PASSWORD_RECOVERY_URL}${USER_ID}/${TOKEN}/`
export const RESEND_EMAIL_URL = (USER_ID) => `${USERS_URL}${USER_ID}/resend-activation-email/`

export const CLIENT_DETAIL_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/`
export const DELETE_CLIENT_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/delete/`
export const VEHICLES_LIST_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/vehicles/`
export const VEHICLE_DETAIL_URL = (USER_ID, VEHICLE_ID) => `${CLIENTS_URL}${USER_ID}/vehicles/${VEHICLE_ID}/`
export const CLIENT_VEHICLES_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/vehicles/`
export const CLIENT_VEHICLES_CSV_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/vehicles-csv/`
export const CLIENT_DRIVERS_URL = (USER_ID, VEHICLE_ID) => `${CLIENTS_URL}${USER_ID}/vehicles/${VEHICLE_ID}/drivers/`
export const CLIENT_DRIVER_URL = (USER_ID, VEHICLE_ID, DRIVER_ID) => `${CLIENT_DRIVERS_URL(USER_ID, VEHICLE_ID)}${DRIVER_ID}/`
export const CLIENT_WEEKLY_REPORT_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/claims/weekly-report/`
export const CLIENT_WEEKLY_REPORT_LOG_URL = (USER_ID) => `${REPORTS_URL}logs/client/${USER_ID}/weekly-report/`
export const CLIENT_NOTIFICATIONS_URL = (USER_ID) => `${CLIENTS_URL}${USER_ID}/client-notification/`
export const CLIENT_TYPES_URL = `${CLIENTS_URL}types/`

export const STATES_URL = `${LOCATIONS_URL}states/`
export const CITIES_URL = (STATE_ID) => `${LOCATIONS_URL}cities/?state=${STATE_ID}`
export const CREATE_CITY_URL = `${LOCATIONS_URL}cities/`

export const VEHICLE_MAKERS_URL = (NAME) => `${VEHICLES_URL}makers/?q=${NAME}`
export const VEHICLE_BRANDS_URL = (NAME, MAKER) => `${VEHICLES_URL}brands/?q=${NAME}&m=${MAKER}`
export const VEHICLE_DRIVERS = (USER_ID, VEHICLE_ID) => `${VEHICLE_DETAIL_URL(USER_ID, VEHICLE_ID)}drivers/`


export const VEHICLE_POLICIES_URL = (USER_ID, VEHICLE_ID) => `${API_BASE_URL}/clients/${USER_ID}/vehicles/${VEHICLE_ID}/policies/`

export const INSURANCE_COMPANIES_URL = `${INSURANCE_URL}companies/`
export const INSURANCE_BROKERS_URL = `${INSURANCE_URL}brokers/`

export const EXTRA_DATA_URL = (USER_ID, VEHICLE_ID, POLICY_ID) =>`${POLICY_DETAIL_URL(USER_ID, VEHICLE_ID, POLICY_ID)}extra-data/`
export const POLICY_EXTRA_DATA = EXTRA_DATA_URL
export const POLICY_DETAIL_URL = (USER_ID, VEHICLE_ID, POLICY_ID) =>`${CLIENTS_URL}${USER_ID}/vehicles/${VEHICLE_ID}/policies/${POLICY_ID}/`
export const POLICY_FILE_URL = (USER_ID, VEHICLE_ID, POLICY_ID) =>`${POLICY_DETAIL_URL(USER_ID, VEHICLE_ID, POLICY_ID)}file/`

export const UPDATE_DOCUMENTS_URL = (USER_ID, VEHICLE_ID) => `${CLIENT_VEHICLES_URL(USER_ID)}${VEHICLE_ID}/docs/`

export const CLAIM_TYPES = `${CLAIMS_URL}types/`
export const CLAIM_NOTES = (USER_ID) => `${CLAIMS_URL}${USER_ID}/notes/`
export const CLAIM_UPDATES = (CLAIM_ID) => `${CLAIMS_URL}${CLAIM_ID}/updates/`
export const CLAIM_UPDATE = (CLAIM_ID) => `${CLAIMS_URL}${CLAIM_ID}/`
export const CLAIM_CLOSE_REPORT = (CLAIM_ID) => `${CLAIMS_URL}${CLAIM_ID}/closing-report/`
export const CLAIM_POCS = (CLAIM_ID) => `${CLAIMS_URL}${CLAIM_ID}/contacts/`
export const CLAIM_CHRONOLOGY = (CLAIM_ID) => `${CHRONOLOGY_URL}claims/${CLAIM_ID}/`
export const CLAIM_NEXT_ACTIVITIES = (CLAIM_ID) => `${CHRONOLOGY_URL}claims/${CLAIM_ID}/next-activities/`


export const CLAIM_BROKER_REPORTS = `${CLAIMS_URL}brokers/weekly-report/`

export const POCS = (POC_ID) => `${CLAIMS_URL}contacts/${POC_ID}/`

export const SUGGESTIONS_UPDATES = (TYPE_ID) => `${CLAIM_TYPES}${TYPE_ID}/suggestions/`



// WEBPACK FOOTER //
// ./src/constants.js